import { extractAgencyFromUrl } from './utils/url';

/**
 * Compose a link to a product based on the agency and environment.
 * If agency is not provided, it will be taken from the current url.
 * If current url does not contain agency, it will use 'compulse360' as default.
 *
 * @param {{
 *   product: 'analytics' | 'mediaplanner' | 'admin' | 'portal' | 'compulse360';
 *   env: 'dev' | 'stg' | 'prod';
 *   agency?: string;
 * }} config
 * @returns {string}
 *
 * @example
 * useLink({ product: 'analytics', agency: 'sinclair', env: 'dev' })
 * // => https://sinclair.analytics.dev.adportal.io
 *
 * @example
 * useLink({ product: 'portal', env: 'dev', agency: 'sinclair' })
 * // => https://sinclair.dev.adportal.io
 *
 * @example
 * useLink({ product: 'analytics', env: 'dev', agency: 'sinclair' })
 * // => https://sinclair.analytics.dev.adportal.io
 */
export const useLink = ({ product, agency = extractAgencyFromUrl(window.location.host), env }) => {
  agency = agency || 'compulse360';
  switch (product) {
    case 'compulse360':
      return env === 'prod'
        ? `https://${agency}.adportal.io`
        : `https://${agency}.${env}.adportal.io`;
    case 'portal':
      return env === 'prod'
        ? `https://${agency}.adportal.io`
        : `https://${agency}.${env}.adportal.io`;
    default:
      return env === 'prod'
        ? `https://${agency}.${product}.adportal.io`
        : `https://${agency}.${product}.${env}.adportal.io`;
  }
};
